/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKrw = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m4 2 1.134 5.999h4.355L11 2h2l1.511 5.999h4.355L20 2h2l-1.2 5.999L22 8v2l-1.6-.001-.4 2L22 12v2l-2.4-.001L18 22h-2l-2.015-8.001h-3.97L8 22H6l-1.6-8.001L2 14v-2l2-.001-.4-2L2 10V8l1.2-.001L2 2zm3.977 11.999H6.268L7 17.877zm9.755 0h-1.709L17 17.877zm-8.747-4H5.512l.378 2h2.591zm3.992 0h-1.954l-.504 2h2.962zm5.511 0h-3.473l.504 2h2.591zM12 6.123 11.527 8h.946z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgKrw as Krw };
